module.exports = __webpack_public_path__ + "static/why-nations-fail-136187cb5c8d2fe3b8ac29847b15125f.jpg";